var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignOut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.49,49.95h-8.2c-5.18,0-9.38-4.2-9.38-9.38V21.82c0-5.18,4.2-9.38,9.38-9.38h8.2 c0.64,0,1.17,0.53,1.17,1.17v3.91c0,0.64-0.53,1.17-1.17,1.17h-8.2c-1.73,0-3.13,1.4-3.13,3.13v18.75c0,1.73,1.4,3.13,3.13,3.13 h8.2c0.64,0,1.17,0.53,1.17,1.17v3.91C25.67,49.42,25.14,49.95,24.49,49.95z M39.04,49.26c-1.46,1.46-4,0.44-4-1.66v-9.38H21.76 c-1.3,0-2.34-1.04-2.34-2.34v-9.38c0-1.3,1.04-2.34,2.34-2.34h13.28v-9.38c0-2.09,2.53-3.13,4-1.66l16.41,16.41 c0.91,0.92,0.91,2.4,0,3.32L39.04,49.26z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOut);
export default __webpack_public_path__ + "static/media/sign_out.0489fd8d30c7bbae4d8ce86a738a1983.svg";
export { ForwardRef as ReactComponent };